import { render } from "./PackageResourceCard.vue?vue&type=template&id=6556f7f0&scoped=true"
import script from "./PackageResourceCard.vue?vue&type=script&lang=js"
export * from "./PackageResourceCard.vue?vue&type=script&lang=js"

import "./PackageResourceCard.vue?vue&type=style&index=0&id=6556f7f0&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6556f7f0"]])

export default __exports__